export const environment = {
  production: true,
  apiUrl: 'https://api-myhrcounsel.project-qa.com/'
};
